import script from "./TeamRoleList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamRoleList.vue?vue&type=script&lang=ts&setup=true"

import "./TeamRoleList.vue?vue&type=style&index=0&id=3654bbc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3654bbc8"]])

export default __exports__